import Header from '@editorjs/header';
import List from '@editorjs/list';
import Paragraph from '@editorjs/paragraph';
import Underline from '@editorjs/underline';
import Quote from '@editorjs/quote';
import EditorJS from '@editorjs/editorjs';
import { Component, OnInit } from '@angular/core';
import { ContractTemplate } from 'src/app/models/contract_template.model';
import { ContractTemplateService } from 'src/app/services/contract_template_service.service';
import { DeleteTemplateDialog } from './dialogs/delete_template_dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { KeyValuePipe } from '@angular/common';

@Component({
    selector: 'contract-template',
    templateUrl: './contract_template.component.html',
    styleUrls: ['./contract_template.component.scss'],
    imports: [MatButton, MatSelectionList, MatProgressBar, MatListOption, MatIcon, MatFormField, MatInput, FormsModule, MatLabel, MatSelect, MatOption, KeyValuePipe]
})
export class ContractTemplateComponent implements OnInit {

    contractTemplates: ContractTemplate[] = [];
    selectedContractTemplate!: ContractTemplate;

    loadingContractTemplates = false;
    loadingContractTemplate = false;
    savingContractTemplate = false;

    contractTemplateKeys = new Map([
        ['NEW', 'New'],
        ['CUSTOMER', 'Customer Contract'],
        ['MSA', 'Master Service Agreement'],
        ['SOS', 'Scope of Services'],
        ['ACH', 'Automated Clearing House'],
    ]);

    editor!: EditorJS;

    constructor(
        private contractTemplateService: ContractTemplateService,
        public dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.getContractTemplates();
    }

    getContractTemplates(): void {
        this.loadingContractTemplates = true;

        this.contractTemplateService
            .getAll([], new Map())
            .subscribe(
                x => {
                    this.contractTemplates = x;
                    this.loadingContractTemplates = false;
                },
                _ => {
                    this.loadingContractTemplates = false;
                }
            );
    }

    getContractTemplate(contractTemplateId: string): void {
        this.loadingContractTemplate = true;

        this.contractTemplateService
            .get([contractTemplateId], new Map())
            .subscribe(
                x => {
                    this.selectedContractTemplate = x;
                    this.setEditorBlocks();
                    this.loadingContractTemplate = false;
                },
                _ => {
                    this.loadingContractTemplate = false;
                }
        );
    }

    selectContractTemplate(contractTemplate: ContractTemplate): void {
        this.getContractTemplate(contractTemplate.contractTemplateId);
    }

    setEditorBlocks(): void {
        this.clearEditor();

        const body = JSON.parse(this.selectedContractTemplate.body);
        this.editor = new EditorJS({
            holder: 'editor-js',
            tools: { Header, List, Paragraph, Quote, Underline, image: SimpleImage },
            data: body,
            readOnly: true,
        });
    }

    newContractTemplate(): void {
        // Initialize ContractTemplate
        this.selectedContractTemplate = new ContractTemplate();
        this.selectedContractTemplate.name = 'Untitled Template';
        this.selectedContractTemplate.contractTemplateKey = 'NEW';

        const name = this.selectedContractTemplate.name;
        const contractTemplateKey = this.selectedContractTemplate.contractTemplateKey;

        // Wipe the editor
        this.clearEditor();

        this.contractTemplateService
            .post([], { name, contractTemplateKey })
            .subscribe(x => {
                this.getContractTemplates();
                this.getContractTemplate(x.contractTemplateId);
            }, _ => {
                this.getContractTemplates();
            });
    }

    saveContractTemplate(): void {
        this.editor.save().then(
            (output: any) => {
                this.selectedContractTemplate.body = JSON.stringify(output);

                const name = this.selectedContractTemplate.name;
                const body = this.selectedContractTemplate.body;
                const contractTemplateKey = this.selectedContractTemplate.contractTemplateKey;
                const id = this.selectedContractTemplate.contractTemplateId;

                this.contractTemplateService
                    .put([id], { name, body, contractTemplateKey })
                    .subscribe(_ => {
                        this.getContractTemplates();
                        this.getContractTemplate(id);
                    }, _ => {
                        this.getContractTemplates();
                        this.getContractTemplate(id);
                    });
            }
        );
    }

    openDeleteContractTemplatePopup(): void {
        const dialogRef = this.dialog.open(DeleteTemplateDialog, {
            width: '250px',
            data: {deleteTemplate: false}
          });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.deleteContractTemplate();
            }
        });
    }

    deleteContractTemplate(): void {
        this.contractTemplateService
            .delete(this.selectedContractTemplate.contractTemplateId)
            .subscribe((_) => {
                this.getContractTemplates();
                this.clearEditor();
                this.selectedContractTemplate = new ContractTemplate();
            });
    }

    clearEditor(): void {
        const editor = document.getElementById('editor-js');

        if (editor) {
            editor.innerHTML = '';
        }
    }
}

class SimpleImage {
  render(){
    return document.createElement('input');
  }

  save(blockContent: { value: any; }){
    return {
      url: blockContent.value
    }
  }
}